/**
 * Format a 24-hour "HH:MM" string (as returned by the API) into a 12-hour
 * Spanish AM/PM label, e.g. "23:59" → "11:59 p. m.", "10:00" → "10:00 a. m.".
 * Returns the input unchanged if it can't be parsed, "" for empty input.
 */
function formatTime12h(hhmm) {
  if (!hhmm || typeof hhmm !== "string") return "";
  const [h, m] = hhmm.split(":").map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return hhmm;
  const period = h < 12 ? "a. m." : "p. m.";
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${hour12}:${String(m).padStart(2, "0")} ${period}`;
}

export { formatTime12h };
